import { TelegramClient } from 'messaging-api-telegram';
import { ParseMode } from 'messaging-api-telegram/dist/TelegramTypes';
import axios from 'axios';
import config from 'error-handler/config';

type Chat = 'error' | 'cargoes';

interface ISendObj {
  label: string;
  value: string;
}


export default class Telegram {
  private readonly BOT_ID?: string;
  private readonly CHAT_ID?: string;

  constructor(type: Chat) {
    this.BOT_ID = type === 'error'
      ? config.TELEGRAM_TOKEN
      : process.env.TELEGRAM_TOKEN_CARGOES;

    this.CHAT_ID = type === 'error'
      ? config.DFA_LOGS_ID
      : process.env.CARGOES_CHAT_ID;
  }

  private escapeMarkdown(text: string) {
    return text.trim().replace(/([_*\[\]()~`>#+\-=|{}.!\\])/g, '\\$1');
  }

  async send(content: string) {
    const escapedText = this.escapeMarkdown(content);
    if (!escapedText) return;

    const url = `https://api.telegram.org/bot${this.BOT_ID}/sendMessage`;

    const response = await axios.post(url, {
      chat_id: this.CHAT_ID,
      text: escapedText,
      parse_mode: 'MarkdownV2',
    });

    return response.data;
  }

  async sendObj(content: ISendObj[], title?: string) {
    let message =
      (title ? `[${this.escapeMarkdown(title)}]\n` : '') +
      content
        .map(
          (item) =>
            `${this.escapeMarkdown(item.label)}: ${this.escapeMarkdown(item.value)}`
        )
        .join('\n');

    message = message
      .replace(/::/g, ':')
      .replace(/\\([+.@-])/g, '$1');

    await this.send(message);
  };
}
